<template>
    <div class="row mb-2">
        <div class="col-4">
            <slot name="label">

            </slot>
        </div>
        <div class="col-8">
                <input-group v-if="hasIcon" :icon="icon">
                    <slot name="input">

                    </slot>
                </input-group>

                <slot v-else name="input">
                    
                </slot>
        </div>
    </div>    
</template>

<script>

import inputGroup from '../../../../../Components/Inputs/InputGroup.vue';

export default {
    name: 'journey-brick-settings-content-item',
    components: {
        inputGroup
    },
    computed: {
        hasIcon() {
            return this.icon != '';
        }
    },
    props: {
        icon: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>

</style>